import * as Redux from '@reduxjs/toolkit';
import { supportsHistory } from 'history/lib/DOMUtils';
import { browserHistory, hashHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import { createLoginReducer, createRootReducer } from './slices';

export function createStore() {
	const historyType = supportsHistory() ? browserHistory : hashHistory;
	const store = Redux.configureStore({
		reducer: createRootReducer(),
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().concat(routerMiddleware(historyType)),
	});
	return store;
}

export type Store = ReturnType<typeof createStore>;

export function createLoginStore() {
	const historyType = supportsHistory() ? browserHistory : hashHistory;
	const store = Redux.configureStore({
		reducer: createLoginReducer(),
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().concat(routerMiddleware(historyType)),
	});
	return store;
}
